<template>
  <div :class="cssClass" data-testid="promolabel" v-if="show">{{ text }}</div>
</template>

<script>
export default {
  name: 'PromoLabel',
  props: {
    text: {
      type: String
    },
    cssClass: {
      type: String
    },
    show: {
      type: Boolean
    }
  }
}
</script>

<style scoped lang="scss">
.promocode {
  color: #008800;
  padding: 0;
  font-weight: bold;
  font-size: 1.1rem;
  width: fit-content;
}
</style>
